// @flow

import type { TimesheetProjection } from '../../common//typings';
import { subtractDates } from '../../utils/Utils';

export default function getClockedInMinutes(lastTimesheetProjection: TimesheetProjection): number {
  const end = lastTimesheetProjection.clockOutLocal || new Date();
  return Math.floor(subtractDates(end, lastTimesheetProjection.clockInLocal) / 1000 / 60);
}
